import { API } from './api';

interface SubcategoryStore {
  baseUrlApi?: string | { value: string };
  lang?: string;
}

interface Params {
  token?: string;
  [key: string]: any;
}

class SubcategoryService extends API {
  constructor(store?: SubcategoryStore, params?: Params, id?: string | number) {
    super(store, params, id);
  }

  override generateUrl(): string {
    const lang = (this.store as SubcategoryStore)?.lang || 'da';
    return ['channel/', lang, '/', this.id].join('');
  }

  async getSubcategory(): Promise<any> {
    return await this.fetchData();
  }
}

export default SubcategoryService;
export { SubcategoryService };
